<template>
  <div class="d-flex flex-column flex-root">
    <div class="d-flex flex-column flex-center flex-column-fluid p-10">
      <div class="text-center">
        <div v-if="loading" class="spinner spinner-primary spinner-lg"></div>
        <h3 v-if="loading" class="mt-5">Autenticando...</h3>
        <h3 v-if="erro" class="text-danger">{{ erro }}</h3>
        <p v-if="erro">
          <a :href="loginUrl" class="btn btn-primary mt-5">Voltar ao login</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import JwtService from "@/core/services/jwt.service";

export default {
  name: "SSOCallback",
  data() {
    return {
      loading: true,
      erro: null
    };
  },
  computed: {
    loginUrl() {
      return process.env.BASE_URL + "login";
    }
  },
  mounted() {
    // Retorno do vínculo do e-mail alternativo (perfil, não login) — o
    // usuário já está autenticado, então NÃO mexe no token/sessão, só volta
    // pro painel e reabre o perfil com um aviso de sucesso.
    if (this.$route.query.vinculado === "1") {
      sessionStorage.setItem("emailAlternativoVinculado", "1");
      window.location.href = "/";
      return;
    }

    const token = this.$route.query.token;

    if (!token) {
      this.erro = "Token de autenticação não recebido.";
      this.loading = false;
      return;
    }

    JwtService.saveToken(token);

    // Se o usuário chegou ao login vindo de um fluxo que precisa voltar
    // (ponte de login do MCP, WEL-5286), devolvemos para onde ele estava
    // indo — senão os parâmetros da autorização se perdem. Sem isso, o SSO
    // funcionaria para entrar no painel, mas quebraria a conexão do
    // assistente, que é justamente o caso que motivou a ponte.
    const retorno = sessionStorage.getItem("retornoAposLogin");
    sessionStorage.removeItem("retornoAposLogin");

    // Só caminho interno: nunca redirecionar para host externo com base em
    // algo guardado no navegador.
    const interno =
      retorno && retorno.startsWith("/") && !retorno.startsWith("//");

    // Usa reload completo (nao router.push) para que o Vuex reinicialize
    // isAuthenticated a partir do token recem-salvo e o guard de rota
    // dispare verificar-login na primeira navegacao (from.name indefinido).
    window.location.href = interno ? retorno : "/";
  }
};
</script>
